import { Link, useLocation } from 'react-router-dom';

export const MarketingFooter = () => {
  const location = useLocation();

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    
    // If we're not on the homepage, navigate first
    if (location.pathname !== '/') {
      window.location.href = `/${hash}`;
      return;
    }
    
    // Smooth scroll to the element
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="marketing-footer">
      <div className="marketing-container">
        <div className="marketing-footer-content">
          <div className="marketing-footer-section">
            <h4>Product</h4>
            <a 
              href="#features" 
              onClick={(e) => handleAnchorClick(e, '#features')}
            >
              Features
            </a>
            <Link to="/pricing">Pricing</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/workspace">Workspace</Link>
          </div>
          <div className="marketing-footer-section">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="marketing-footer-section">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
        <div className="marketing-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Simcarlo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
